import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import global_en from "./translations/En/global.json";
import global_tr from "./translations/Tr/global.json";
import global_fr from "./translations/Fr/global.json";
import global_nl from "./translations/Nl/global.json";

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { I18nextProvider } from "react-i18next";

i18next.use(LanguageDetector).init({
  interpolation: { escapeValue: false },
  fallbackLng: "en",
  defaultNS: "global",
  resources: {
    en: { global: global_en },
    tr: { global: global_tr },
    fr: { global: global_fr },
    nl: { global: global_nl },
  },
  detection: {
    // 1) check path (/:lang/)
    // 2) then browser settings
    order: ["path", "navigator"],
    lookupFromPathIndex: 0,
    // don’t cache language in localStorage or cookies
    caches: [],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
